import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth0 } from '../../auth/AuthProvider';
import { parseCallbackHashSession } from '../../auth/auth0Api';

const CallbackPage = () => {
  const { isLoading, isAuthenticated } = useAuth0();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(window.location.search);
  const authError = searchParams.get('error');
  const authErrorDescription = searchParams.get('error_description');

  useEffect(() => {
    // Magic-link / passwordless redirects may deliver tokens in the hash.
    parseCallbackHashSession();

    if (isLoading || authError) {
      return;
    }

    if (!isAuthenticated && !window.location.hash.includes('access_token')) {
      return;
    }

    const returnTo = localStorage.getItem('redirectAfterLogin') || '/';
    localStorage.removeItem('redirectAfterLogin');
    navigate(returnTo, { replace: true });
  }, [authError, isAuthenticated, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center px-4">
        <p>Processing authentication...</p>
      </div>
    );
  }

  if (authError) {
    return (
      <div className="flex min-h-screen items-center justify-center px-4">
        <div className="max-w-md text-center">
          <h1 className="mb-2 text-xl font-semibold">Sign-in failed</h1>
          <p className="mb-4 text-gray-600">
            {authErrorDescription?.replace(/\+/g, ' ') ??
              'Authentication could not be completed.'}
          </p>
          <Link
            to="/login"
            className="text-blue-600 underline hover:text-blue-800"
          >
            Try again
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <p>Redirecting...</p>
    </div>
  );
};

export default CallbackPage;
